import { ChainId } from '@ui/types/chain';
import { getContract, PublicClient, WalletClient } from 'viem';

import LimitOrderFacet from '../abis/LimitOrderFacet';
import { getContractAddress } from '../constants';

export const getLimitOrderFacet = ({
  publicClient,
  walletClient,
  chainId,
}: {
  publicClient: PublicClient;
  walletClient?: WalletClient;
  chainId: ChainId;
}) => {
  const address = getContractAddress('LeverUp', chainId);
  if (!address) throw new Error('Contract address not found');

  return getContract({
    abi: LimitOrderFacet,
    address: address,
    client: {
      public: publicClient,
      wallet: walletClient,
    },
  });
};
